<script setup>
import { computed, defineEmits, defineProps, ref } from "vue";
import CalendarIcon from "@/components/Icons/CalendarIcon.vue";
import { useLK } from "@/controllerLK/LKstore";

const props = defineProps({
  modelValue: {
    type: Array,
    required: true
  }
});

const emit = defineEmits(["update:modelValue"]);

const calendarRef = ref(null);

const LKStore = useLK();
const activeLanguage = computed(() => {
  try {
    return LKStore.user.language.toLowerCase();
  } catch (error) {
    return "ru";
  }
});

const handleDateChange = (value) => {
  if (value[1] === null) {
    value[1] = new Date();
  }
  emit("update:modelValue", value);
};

const handleButtonClick = () => {
  if (calendarRef.value?.$el) {
    setTimeout(() => calendarRef.value.$el.click(), 0);
  }
};
</script>

<template>
  <ButtonIconNeutralSecondary
    class="calendar-input"
    :active="calendarRef?.isShowDatePicker"
    size="large"
    @click.stop="handleButtonClick"
  >
    <GlobusCalendar
      ref="calendarRef"
      :use-custom-template="true"
      :model-value="props.modelValue"
      :use-confirmation="true"
      placement="bottom-right"
      :locale="activeLanguage"
      @click.stop
      @update:model-value="handleDateChange"
    >
      <CalendarIcon class="icon" />
    </GlobusCalendar>
  </ButtonIconNeutralSecondary>
</template>

<style scoped lang="scss">
.icon {
  width: 20px;
  height: 20px;
  font-size: 22px;
}
</style>